import * as React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  Container,
  Typography,
  useTheme,
  useMediaQuery,
  Input,
} from "@mui/material";

import { tokens } from "../../theme";
import Grid from "@mui/material/Grid";
import { Paper, IconButton } from "@mui/material";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import UpdateIcon from "@mui/icons-material/Update";
import { useState, useRef } from "react";
import SearchIcon from "@mui/icons-material/Search";

import Select from "react-select";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch, { SwitchProps } from "@mui/material/Switch";

import "./style.css";
import { ToastContainer } from "react-toastify";
import { getApi, postApi, putApi } from "../../services/axiosInstance.js";
import { API_PATH } from "../../services/apipath";
import { Controller, useForm } from "react-hook-form";
import Modal from "react-modal";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import Edit from "@mui/icons-material/Edit";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import Moment from "react-moment";

const options = [
  { value: 0, label: "Demo" },
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" },
];

const planType = [
  { value: 0, label: "Both" },
  { value: 1, label: "Core" },
  { value: 2, label: "Academic" },
];
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: "10010",
  },
};

const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [selectedValue, setSelectedValue] = useState("");
  const [companyObject, setCompanyObject] = useState([]);
  const [count, setCount] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [status, setStatus] = useState(0);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const fetchInstitute = async () => {
    try {
      const res = await getApi(API_PATH.SUPER_ADMIN.INSTITUTE_LIST);
      if (res.status === 200) {
        setCompanyObject(res.data);
      }
    } catch (error) {
      console.log();
    }
  };

  const fetchInstituteCount = async () => {
    try {
      const res = await getApi(API_PATH.SUPER_ADMIN.INSTITUTE_COUNT);
      if (res.status === 200) {
        setCount(res.data);
      }
    } catch (error) {
      // console.log(error, "count");
    }
  };

  React.useEffect(() => {
    fetchInstitute();
    fetchInstituteCount();
  }, []);

  const filteredData = companyObject.filter((item) => {
    const matchesName = item.instituteName
      .toLowerCase()
      .includes(searchQuery.toLowerCase());

    const matchesLocation = item.location
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const matchesSearch = matchesName || matchesLocation;
    if (status) {
      return matchesSearch && item.InstituteStatus === parseInt(status);
    } else {
      return matchesSearch && item.InstituteStatus === parseInt(status);
    }
    return matchesSearch;
  });

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const inputRef = useRef(null);
  const [image, setImage] = useState("");

  const handleImageClick = () => {
    inputRef.current.click();
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setImage(event.target.files[0]);
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [success, setSuccess] = React.useState(false);

  const IOSSwitch = styled((props) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor:
            theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const isNonMobile = useMediaQuery("(min-width:400px)");

  const handleFormSubmit = async (data) => {
    const formData = new FormData();
    if (imageUpdate) {
      formData.append("uploadImage", imageUpdate);
    }

    formData.append("instituteId", selectedInstitute._id);
    formData.append(
      "instituteName",
      data.InstituteName ? data.InstituteName : selectedInstitute.instituteName
    );
    formData.append("password", data.password);
    formData.append("email", data.email);
    formData.append("phoneNumber", data.contact);
    formData.append("location", data.loc);
    // console.log(payload);
    try {
      const res = await putApi(
        API_PATH.SUPER_ADMIN.EDIT_INSTITUTE_DETAILS,
        formData
      );
      if (res.status == 200) {
        toast.success("Updated successfully");
        fetchInstitute();
        await closeModal();
      }
    } catch (error) {}
    // handleClose(); // Close the modal after form submission
  };
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [instituteId, setinstituteId] = React.useState("");
  const [selectedInstitute, setSelectedInstitute] = React.useState([]);

  function openModal(data, id) {
    setIsOpen(true);
    setinstituteId(id);
    setSelectedInstitute(data);
  }

  function closeModal() {
    setIsOpen(false);
    setinstituteId("");
    setSelectedInstitute([]);
  }

  // <=================add subsp=====================>

  const AddSubscription = async (days) => {
    try {
      const payload = {
        id: iid,
        days: parseInt(days),
      };
      const res = await postApi(API_PATH.SUPER_ADMIN.ADD_SUBSRIPTIONS, payload);
      if (res.status === 201) {
        toast.success("Subscription added successfully");
        closeAddSubscriptionModal();
      } else {
        toast.error("Failed to add subscription. Please try again.");
      }
    } catch (error) {
      toast.error("Failed to add subscription. Please try again.");
    }
  };

  const saveAddSubscription = () => {
    if (subscriptionDays >= 1 && subscriptionDays <= 365) {
      AddSubscription(subscriptionDays);
    } else {
      alert("Please enter a valid number of days (1-365).");
    }
  };

  const [isAddSubscriptionModalOpen, setIsAddSubscriptionModalOpen] =
    useState(false);
  const [iid, setiid] = useState("");
  const [subscriptionDays, setSubscriptionDays] = useState(0);
  const [selectedPlan, setSelectedPlan] = useState("");

  const openAddSubscriptionModal = (id) => {
    console.log(id);
    setiid(id);
    setIsAddSubscriptionModalOpen(true);
  };

  const closeAddSubscriptionModal = () => {
    setIsAddSubscriptionModalOpen(false);
    setSubscriptionDays(0);
    setSelectedPlan("");
  };

  // const saveAddSubscription = () => {
  //   console.log(`Days: ${subscriptionDays}`);
  //   closeAddSubscriptionModal();
  // };

  // Handle Plan Change
  const handlePlanChange = (plan) => {
    setSelectedPlan(plan);
  };

  const [imageUpdate, setImageUpdate] = useState("");

  const handleImageChangeUpdate = (event) => {
    const file = event.target.files[0];
    console.log(file);
    setImageUpdate(event.target.files[0]);
  };
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    control: control1,
    formState: { errors: errors1 },
  } = useForm();

  const AddRequestInstitute = async (data) => {
    const formData = new FormData();
    if (image) {
      formData.append("image", image);
    }

    formData.append("instituteName", data.name);
    formData.append("domain", data.domain);
    formData.append("email", data.email);
    formData.append("planType", data.planType.value);
    formData.append("phoneNumber", data.mob);
    formData.append("demo", data.demo === true ? 1 : 0);

    try {
      const res = await postApi(
        API_PATH.SUPER_ADMIN.ADD_INSTITUTE_REQUEST,
        formData
      );
      if (res.status == 201) {
        toast.success("Requested Successfully ");
        fetchInstitute();
      }
    } catch (error) {
      toast.error("Institute with same email or phone numbr already exists");
      // console.log(error, "hsvhgdcvshgcvh");
    }
  };

  return (
    <Container
      backgroundColor={colors.primary[900]}
      className="border-5"
      // sx={{ backgroundColor: "#1F2A40" }}
    >
      <Grid
        container
        alignItems="center"
        spacing={0.5}
        sx={{
          padding: "16px",
          borderTopLeftRadius: "16px",
          borderTopRightRadius: "16px",
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
          backgroundColor: "#ffffff",
          height: "95vh",
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={9}
          sx={{
            backgroundColor: "#F4F7FF",
            borderRadius: "15px",
            padding: "10px",
            height: "100%",
            overflow: "scroll",
          }}
        >
          <Box
            className="border-5"
            // height={500}
            sx={{
              borderTopLeftRadius: "16px",
              borderTopRightRadius: "0px",
              borderBottomLeftRadius: "16px",
              borderBottomRightRadius: "0px",
            }}
          >
            <Box
              p="0 20px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid
                container
                alignItems="center"
                spacing={0}
                sx={{ marginBottom: "20px" }}
              >
                <Grid item xs={12} sm={6} md={4}>
                  <div>
                    <Typography
                      variant="h4"
                      style={{ color: "#1F2A40", fontWeight: "600" }}
                    >
                      Institutes List
                    </Typography>
                    <Typography variant="h6" style={{ color: "#000000" }}>
                      Welcome to PTE Champion
                    </Typography>
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={5}
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                >
                  <Box
                    display="flex"
                    // backgroundColor="white"
                    // borderRadius="3px"
                    // border="1px solid grey"
                  >
                    <input
                      type="text"
                      style={{
                        marginLeft: 2,
                        flex: 1,
                        color: "black",
                        borderRadius: "10px",
                        border: "solid 1px #e2e2e2",
                      }}
                      placeholder="Search"
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <IconButton type="button" sx={{ p: 1 }}>
                      <SearchIcon className="text-secondary" />
                    </IconButton>
                  </Box>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={3}
                  display="flex"
                  justifyContent="center"
                  alignItems="end"
                >
                  <Select
                    className="w-100 text-dark"
                    options={options}
                    onChange={(e) => setStatus(e.value)}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box height="100%" m="-20px 0 0 0" sx={{ overflowY: "scroll" }}>
              <table className="table text-dark">
                {filteredData.length > 0 ? (
                  <tbody>
                    {filteredData.map((i, j) => {
                      return (
                        <Card
                          sx={{
                            padding: "1px",
                            backgroundColor: "transparent",
                            display: "flex",
                            flexDirection: "row",
                            margin: "12px",
                            border: "solid 1px #b8b8b8",
                            boxShadow: "none",
                            borderRadius: "15px",
                          }}
                        >
                          <Grid
                            container
                            alignItems="center"
                            spacing={0}
                            sx={{ background: "transparent" }}
                          >
                            <Grid
                              item
                              sx={{
                                marginRight: "10px",
                                background: "transparent",
                              }}
                            >
                              <th className="px-3 py-2 rounded-3 text-dark nostudent">
                                {i.studentsId.length}
                              </th>
                            </Grid>

                            <Grid item>
                              <div className="d-flex align-items-center">
                                <Avatar
                                  alt={i.instituteName}
                                  src={`${process.env.REACT_APP_BASE_URL}${i.image}`}
                                  sx={{
                                    width: 24,
                                    height: 24,
                                    marginRight: "5px",
                                  }}
                                  variant="rounded"
                                />

                                <Typography
                                  variant="h6"
                                  sx={{ fontSize: "16px" }}
                                >
                                  {i.instituteName} (
                                  {i.planType === 0
                                    ? "Both"
                                    : i.planType === 1
                                    ? "Core"
                                    : "Academic"}{" "}
                                  )
                                </Typography>

                                <Edit
                                  sx={{
                                    mx: 1,
                                    "&:hover": {
                                      cursor: "pointer",
                                    },
                                  }}
                                  onClick={() => openModal(i, i._id)}
                                />

                                <EditCalendarIcon
                                  sx={{
                                    "&:hover": {
                                      cursor: "pointer",
                                    },
                                  }}
                                  onClick={() =>
                                    openAddSubscriptionModal(i._id)
                                  }
                                />
                                <div>
                                  <ToastContainer
                                    toastContainerProps={{
                                      style: {
                                        zIndex: 10000,
                                      },
                                    }}
                                  />
                                  {/* Modal */}
                                  {isAddSubscriptionModalOpen && (
                                    <div className="modal-overlay">
                                      <div className="modal-content">
                                        <h2>Add Subscription</h2>
                                        <button
                                          onClick={closeAddSubscriptionModal}
                                          className="close-modal-btn"
                                        >
                                          X
                                        </button>

                                        {/* Days Input */}
                                        <div className="subscription-input">
                                          <input
                                            type="number"
                                            min={1}
                                            max={365}
                                            value={subscriptionDays}
                                            onChange={(e) =>
                                              setSubscriptionDays(
                                                e.target.value
                                              )
                                            }
                                          />
                                          <span className="text-dark">
                                            Days (1 - 365)
                                          </span>
                                          {/* Validation Message */}
                                          {subscriptionDays < 1 ||
                                          subscriptionDays > 365 ? (
                                            <p
                                              className="error-message"
                                              style={{ color: "red" }}
                                            >
                                              Please enter a value between 1 and
                                              365.
                                            </p>
                                          ) : null}
                                        </div>

                                        {/* Save Button */}
                                        <button
                                          onClick={() => saveAddSubscription()}
                                          className="save-btn"
                                          disabled={
                                            subscriptionDays < 1 ||
                                            subscriptionDays > 365
                                          }
                                        >
                                          Add Subscription
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <Typography sx={{ fontSize: "14px" }}>
                                {i.email}
                              </Typography>
                              <Typography sx={{ fontSize: "13px" }}>
                                {i.password}
                              </Typography>
                            </Grid>
                          </Grid>

                          <Grid sx={{ width: "150px" }}>
                            {/* <Typography sx={{ fontSize: "12px" }}>
                              {i._id}
                            </Typography> */}
                            <Typography sx={{ fontSize: "15px" }}>
                              <Moment format="DD-MM-YYYY">{i.createdAt}</Moment>
                            </Typography>

                            <Typography sx={{ fontSize: "15px" }}>
                              <Moment format="DD-MM-YYYY">
                                {i.planExpireIn}
                              </Moment>
                            </Typography>

                            <Typography sx={{ fontSize: "14px" }}>
                              {i.phoneNumber}
                            </Typography>

                            <Typography sx={{ fontSize: "13px" }}>
                              {i.domain}
                            </Typography>

                            <Typography sx={{ fontSize: "13px" }}>
                              {i.location}
                            </Typography>
                          </Grid>
                        </Card>
                      );
                    })}
                  </tbody>
                ) : (
                  <h4 className="mt-3 text-center">No data found</h4>
                )}
              </table>
            </Box>
          </Box>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: "100%",
          }}
        >
          <Box
            gridColumn="span 4"
            gridRow="span 3"
            backgroundColor={colors.primary[900]}
            className="border-5"
            overflow="scroll"
            height="100%"
            sx={{
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "16px",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "16px",
            }}
          >
            <Paper
              sx={{
                padding: "16px",
                margin: "10px",
                backgroundColor: "#f7cd48b8",
                textAlign: "center",
                borderRadius: "14px",
                boxShadow: "none",
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontWeight: "600", color: "black" }}
              >
                {count.totalInstitute}
              </Typography>
              <Typography variant="h5" sx={{ color: "black" }}>
                Total Institutes
              </Typography>
            </Paper>

            <Paper
              sx={{
                padding: "16px",
                margin: "10px",
                backgroundColor: "#007FA385",
                textAlign: "center",
                borderRadius: "14px",
                boxShadow: "none",
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontWeight: "600", color: "black" }}
              >
                {count.ActiveInstitute}
              </Typography>
              <Typography variant="h5" sx={{ color: "black" }}>
                Active Institutes
              </Typography>
            </Paper>

            <Paper
              sx={{
                padding: "16px",
                margin: "10px",
                backgroundColor: "#1F2A4063",
                textAlign: "center",
                borderRadius: "14px",
                boxShadow: "none",
              }}
            >
              <Typography
                variant="h2"
                sx={{ fontWeight: "600", color: "black" }}
              >
                {count.DemoInstitute}
              </Typography>
              <Typography variant="h5" sx={{ color: "black" }}>
                Demo Institutes
              </Typography>
            </Paper>

            <Paper
              sx={{
                padding: "16px",
                margin: "10px",
                marginTop: "10px",
                backgroundColor: "#007FA385",
                borderRadius: "14px",
                boxShadow: "none",
              }}
            >
              <form onSubmit={handleSubmit1(AddRequestInstitute)}>
                <div className="text-center">
                  <Input
                    type="file"
                    accept="image/*"
                    id="image-input"
                    style={{ display: "none" }}
                    onChange={handleImageChange}
                  />
                  <label htmlFor="image-input">
                    <IconButton color="primary" component="span">
                      <Avatar
                        alt=""
                        src={image ? URL.createObjectURL(image) : ""}
                        sx={{ width: 56, height: 56 }}
                      />
                    </IconButton>
                  </label>
                </div>

                <Typography variant="h5" className="text-center text-dark mb-3">
                  Register
                </Typography>

                <TextField
                  label="Name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  {...register1("name", {
                    required: "Name is required",
                    minLength: {
                      value: 2,
                      message: "Name must be at least 4 characters long",
                    },
                    maxLength: {
                      value: 30,
                      message: "Name must be less than 20 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z\s]+$/,
                      message: "Name can only contain letters and spaces",
                    },
                  })}
                  error={!!errors1.name}
                  helperText={errors1.name?.message}
                  FormHelperTextProps={{ style: { margin: 0 } }}
                />

                <TextField
                  label="Domain"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  {...register1("domain", {
                    required: "Domain is required",
                    pattern: {
                      value: /^[a-zA-Z0-9-]+\.(com|in|info|net|org)$/i,
                      message: "Please enter a valid  Domain",
                    },
                  })}
                  error={!!errors1.domain}
                  helperText={errors1.domain?.message}
                  FormHelperTextProps={{ style: { margin: 0 } }}
                />

                <TextField
                  label="Mobile Number"
                  variant="outlined"
                  size="small"
                  defaultValue="+91 "
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  {...register1("mob", {
                    required: "Mobile Number is required",
                    validate: (value) => {
                      const numberWithoutCountryCode = value
                        .replace("+91", "")
                        .trim();
                      if (!/^[0-9]\d{9}$/.test(numberWithoutCountryCode)) {
                        return "Please enter a valid 10-digit mobile number";
                      }
                      return true;
                    },
                  })}
                  error={!!errors1.mob}
                  helperText={errors1.mob?.message}
                  FormHelperTextProps={{ style: { margin: 0 } }}
                />

                <TextField
                  label="Email"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  {...register1("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                      message: "Please enter a valid email address",
                    },
                  })}
                  error={!!errors1.email}
                  helperText={errors1.email?.message}
                  FormHelperTextProps={{ style: { margin: 0 } }}
                />

                <Controller
                  name="planType"
                  control={control1}
                  defaultValue=""
                  rules={{
                    required: "Plan type is required",
                    validate: (value) =>
                      value !== "" || "You must select a plan",
                  }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={planType}
                      className="w-100 text-dark mb-2"
                      placeholder="Select a plan"
                    />
                  )}
                />

                <TextField
                  label="Location"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{ marginBottom: "10px" }}
                  {...register1("loc", {
                    required: "location is required",
                    pattern: {
                      value: /^[a-zA-Z\s]+$/,
                      message: "locatiion can only contain letters and spaces",
                    },
                  })}
                  error={!!errors1.loc}
                  helperText={errors1.loc?.message}
                  FormHelperTextProps={{ style: { margin: 0 } }}
                />

                <FormGroup>
                  <FormControlLabel
                    control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
                    label="Add 1 day Demo"
                    sx={{ display: "flex", justifyContent: "center" }}
                    {...register1("demo", {
                      required: "demo  is required",
                    })}
                    error={!!errors1.demo}
                    helperText={errors1.demo?.message}
                    FormHelperTextProps={{ style: { margin: 0 } }}
                  />
                </FormGroup>

                <Stack
                  direction="row"
                  className="d-flex justify-content-center"
                >
                  <Button
                    type="submit"
                    className="px-5 py-3 text-dark mainsidebarbtn"
                    fullWidth
                    sx={{
                      backgroundColor: "#f8cc40",
                      borderRadius: "9px",
                      "&:hover": {
                        backgroundColor: "#1F2A4063", // Change the background color on hover
                        color: "#FFFFFF", // Change the text color on hover
                      },
                    }}
                    variant="contained"
                    startIcon={<UpdateIcon />}
                  >
                    Register
                  </Button>
                </Stack>
              </form>
            </Paper>
          </Box>
        </Grid>
      </Grid>

      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="d-flex justify-content-between align-items-center mb-0">
          <h2 className="text-dark"> Edit Institute</h2>
          <IconButton onClick={closeModal}>
            <Close sx={{ color: "#000" }} />
          </IconButton>
        </div>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <Box
            display="grid"
            gap="10px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 4",
              },
            }}
          >
            <div className="text-center">
              <Input
                type="file"
                accept="image/*"
                id="image-input-update"
                style={{ display: "none" }}
                onChange={handleImageChangeUpdate}
              />
              <label htmlFor="image-input-update">
                <IconButton color="primary" component="span">
                  <Avatar
                    alt={selectedInstitute.instituteName}
                    src={
                      imageUpdate
                        ? URL.createObjectURL(imageUpdate)
                        : selectedInstitute.image
                    }
                    sx={{ width: 56, height: 56 }}
                  />
                </IconButton>
              </label>
            </div>

            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Institute Name"
              name="firstName"
              defaultValue={selectedInstitute.instituteName}
              sx={{ gridColumn: "span 4", backgroundColor: "#F2F0F0" }}
              InputProps={{
                style: { color: "#000000" },
                placeholder: "Institute Name",
              }}
              InputLabelProps={{
                style: { color: "#000000" },
              }}
              {...register("InstituteName", {
                required: "Institute Name is required",
                minLength: {
                  value: 3,
                  message: "Institute Name must be at least 3 characters long",
                },
                maxLength: {
                  value: 20,
                  message: "Institute Name must be less than 20 characters",
                },
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Institute Name can only contain letters and spaces",
                },
              })}
              error={!!errors.InstituteName}
              helperText={errors.InstituteName?.message}
              FormHelperTextProps={{ style: { margin: 0 } }}
            />

            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Email"
              name="email"
              defaultValue={selectedInstitute.email}
              sx={{ gridColumn: "span 4", backgroundColor: "#F2F0F0" }}
              InputProps={{
                style: { color: "#000000" }, // Text color
                placeholder: "First Name",
              }}
              InputLabelProps={{
                style: { color: "#000000" }, // Label color
              }}
              // {...register("email", {
              //   required: "Email is required",
              //   pattern: {
              //     value: /^[a-zA-Z0-9._%+-]+@(gmail|yahoo|mail)\.com$/i,
              //     message: "Please enter a valid  email address",
              //   },
              // })}

              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: "Please enter a valid email address",
                },
              })}
              error={!!errors.email}
              helperText={errors.email?.message}
              FormHelperTextProps={{ style: { margin: 0 } }}
            />

            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Password"
              name="password"
              defaultValue={selectedInstitute.password}
              sx={{ gridColumn: "span 4", backgroundColor: "#F2F0F0" }}
              InputProps={{
                style: { color: "#000000" }, // Text color
                placeholder: "Password",
              }}
              InputLabelProps={{
                style: { color: "#000000" }, // Label color
              }}
              {...register("password", {
                required: "Password is required",
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]/i,
                  message: "Password",
                },
              })}
              error={!!errors.password}
              helperText={errors.password?.message}
              FormHelperTextProps={{ style: { margin: 0 } }}
            />

            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Contact Number"
              name="contact"
              defaultValue={selectedInstitute.phoneNumber}
              sx={{ gridColumn: "span 4", backgroundColor: "#F2F0F0" }}
              InputProps={{
                style: { color: "#000000" }, // Text color
                placeholder: "Contact Number",
              }}
              InputLabelProps={{
                style: { color: "#000000" }, // Label color
              }}
              {...register("contact", {
                required: "Mobile Number is required",
                validate: (value) => {
                  const numberWithoutCountryCode = value
                    .replace("+91", "")
                    .trim();
                  if (!/^[0-9]\d{9}$/.test(numberWithoutCountryCode)) {
                    return "Please enter a valid 10-digit mobile number";
                  }
                  return true;
                },
              })}
              error={!!errors.contact}
              helperText={errors.contact?.message}
              FormHelperTextProps={{ style: { margin: 0 } }}
            />

            <TextField
              fullWidth
              variant="filled"
              type="text"
              label="Location"
              name="location"
              defaultValue={selectedInstitute.location}
              sx={{ gridColumn: "span 4", backgroundColor: "#F2F0F0" }}
              InputProps={{
                style: { color: "#000000" }, // Text color
                placeholder: "location",
              }}
              InputLabelProps={{
                style: { color: "#000000" }, // Label color
              }}
              {...register("loc", {
                required: "location is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "locatiion can only contain letters and spaces",
                },
              })}
              error={!!errors.loc}
              helperText={errors.loc?.message}
              FormHelperTextProps={{ style: { margin: 0 } }}
            />
          </Box>

          <Box display="flex" justifyContent="end" mt="5px">
            <Button
              type="submit"
              color="secondary"
              variant="contained"
              sx={{
                backgroundColor: "#f8cc40",
                borderRadius: "9px",
                paddingX: "40px",
                paddingY: "10px",
                "&:hover": {
                  backgroundColor: "#007FA3", // Change the background color on hover
                  color: "#FFFFFF", // Change the text color on hover
                },
              }}
            >
              Update
            </Button>
          </Box>
        </form>
      </Modal>
    </Container>
  );
};

export default Dashboard;
